import { Observable } from 'rxjs';
import { ADSClickRequest, ADSService, ADSViewRequest, BaseResponse } from '@api/backend';
import { Injectable } from '@angular/core';
import { AdsRepository } from '@core/repositories/ads.repository';

@Injectable()
export class AdsWebRepository extends AdsRepository {

  public constructor(
    private adsService: ADSService,
  ) {super();}

  public postView(ads_id: string, body: ADSViewRequest): Observable<BaseResponse> {
    return this.adsService.postAdsViewAdsAdsIdViewPost(ads_id, body);
  }

  public postClick(ads_id: string, body: ADSClickRequest): Observable<BaseResponse> {
    return this.adsService.postAdsClickAdsAdsIdClickPost(ads_id, body);
  }
}